import { Brand, Market } from '@org-avp/models';
import { DealerId } from '@volkswagen-onehub/mydealer-service';
import { BrandIdentifier } from '@volkswagen-onehub/gfa-dealer-context-service';
import { Locale } from '@org-avp/avp-hck-dga-customerui-commons';
import { getI18nLocale } from '@/util/localization';
import { vwMarketSites } from './vwp/marketConfig';
import { vwnMarketSites } from './vwn/marketConfig';

export interface MarketWebsites {
  locale?: Locale;
  configurator?: string;
  testdrive?: string;
}

export interface TestDriveData {
  id?: DealerId;
  brand?: BrandIdentifier;
  carlineId?: string;
  market?: Market;
}

export const constructQueryString = (
  vehicleTypeParameter: string,
  testdriveData: TestDriveData,
): string => {
  const parts = [`category-app=${vehicleTypeParameter}`];

  if (testdriveData.carlineId) {
    parts.unshift(`carlineId-app=${testdriveData.carlineId}`);
  }

  if (testdriveData.brand && testdriveData.id) {
    parts.push(`dealerId-app=${testdriveData.brand}${testdriveData.id}`);
  }

  /*
   The norwegian URL includes the parameter &campaignID=digital-giveaway to
   ensure that the NOR market can track test drive bookings via their CRM.
  */
  if (testdriveData.market && testdriveData.market === Market.NOR) {
    parts.push(`campaignID=digital-giveaway`);
  }

  return parts.join('&');
};

export const getMarketWebsites = (
  testdriveData: TestDriveData,
  locale: Locale,
  marketingCode?: string,
  market?: Market,
  brand?: Brand,
): MarketWebsites => {
  if (!marketingCode || !market) {
    return {};
  }
  const isCommercialVehicles =
    (typeof brand !== 'undefined' && brand === Brand.VW_NUTZFAHRZEUGE) ||
    marketingCode.startsWith('N');
  const vehicleTypeParameter = isCommercialVehicles ? 'commercial' : 'private';

  const marketSiteMap = isCommercialVehicles ? vwnMarketSites : vwMarketSites;
  const localeConfig = marketSiteMap[market]?.filter(
    (details) => details.locale === getI18nLocale(locale),
  );

  const configuratorSite = localeConfig?.map((details) => details.configurator).at(0);
  const testdriveSite = localeConfig?.map((details) => details.testdrive).at(0);

  const queryString = constructQueryString(vehicleTypeParameter, testdriveData);
  const testdriveQuerySeparator = testdriveSite?.includes('?') ? '&' : '?';

  return {
    configurator:
      configuratorSite &&
      `${configuratorSite}/__app/route:configure.app?marketingCode-app=${marketingCode}`,
    testdrive: testdriveSite && `${testdriveSite}${testdriveQuerySeparator}${queryString}`,
  };
};
